import(/* webpackMode: "eager", webpackExports: ["TourismNav"] */ "/app/app/(tourism)/tourism/components/TourismNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
